import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-setting-sidebar',
  templateUrl: './setting-sidebar.component.html',
  styleUrls: ['./setting-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SettingSidebarComponent implements OnInit {
  a: string;

  constructor() {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {}

  /**
   * This function is used to set the defaultn data
   */
  aa() {
    this.a = 'true';
  }
}
